'use strict';

angular.module('far.models.post', [])
    .service('Post', function($log, $http) {
        this.new = function (data) {
            return new Post(data);
        };

        this.get = function (routeId, callback) {
            var route = new Post({
                slides_files: []
            });

            if (routeId > 0) {
                $http.get(Routing.generate('api_get_post', {post: routeId}))
                    .then(function (response) {
                        route.update(response.data);

                        if (typeof callback == 'function') {
                            callback(route);
                        }
                    }, function errorCallback(response) {
                        $log.error(response);
                    });
            }

            return route;
        };

        function Post(data) {
            angular.merge(this, data);

            Object.defineProperty(this, 'update', {
                enumerable: false,
                get: function () {
                    return function (data) {
                        angular.merge(this, data);
                        return this;
                    }
                }
            });

            Object.defineProperty(this, 'save', {
                enumerable: false,
                get: function () {
                    return function () {
                        var method = this.id ? 'put' : 'post',
                            url = this.id ?
                                Routing.generate('api_put_post', {post: this.id}) :
                                Routing.generate('api_post_post');

                        var data = angular.merge({}, this);

                        if (angular.isObject(data.rubric) ) {
                            data.rubric = data.rubric.id;
                        }

                        if ( angular.isArray( data.disciplines ) ) {
                            data.disciplines = data.disciplines.map(function(discipline) {
                                return discipline.id;
                            });
                        }

                        if ( angular.isArray( data.mountain_areas ) ) {
                            data.mountain_areas = data.mountain_areas.map(function(mountain_area) {
                                return mountain_area.id;
                            });
                        }

                        if ( angular.isArray( data.post_user_qualification_groups ) ) {
                            data.post_user_qualification_groups = data.post_user_qualification_groups.map(function(group) {
                                return group.id;
                            });
                        }

                        if ( angular.isObject( data.image ) ) {
                            data.image = data.image.id;
                        }

                        return $http[method](url, data);
                    }
                }
            });
        }
    });